import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getVotingEscrowContract } from '~/contracts/getVotingEscrowContract'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useWallet } from '~/lib/useWallet'
import { useVESISParams } from '../../../hooks/useVESISParams'

export function useWithdrawLock() {
	const { config, provider } = useVESISParams()

	const { signer, account } = useWallet()

	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: async () => {
			const contract = getVotingEscrowContract(config, provider).connect(
				signer
			)

			const tx = await contract.withdraw()

			await tx.wait()
		},
		onSuccess() {
			queryClient.resetQueries({
				queryKey: sisTokenKeys.balance(config.chain.id, account),
			})
			queryClient.resetQueries({ queryKey: ['sis-lock'] })
		},
		onError(error) {
			console.error('Error withdrawing lock:', error)
		},
	})
}
